import { render } from "./origins.vue?vue&type=template&id=5075b023"
import script from "./origins.vue?vue&type=script&lang=js"
export * from "./origins.vue?vue&type=script&lang=js"

import "./origins.vue?vue&type=style&index=0&id=5075b023&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__